module.exports = __webpack_public_path__ + "static/media/key-skeleton.2e58f827.svg";